import { render, staticRenderFns } from "./taociMain.vue?vue&type=template&id=d47029b0&scoped=true"
import script from "./taociMain.vue?vue&type=script&lang=js"
export * from "./taociMain.vue?vue&type=script&lang=js"
import style0 from "./taociMain.vue?vue&type=style&index=0&id=d47029b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d47029b0",
  null
  
)

export default component.exports